import React from "react";
import { createRoot } from "react-dom/client";
import { Box } from "@material-ui/core";
import App from "./App";
import "./scss/main.css";
import { Provider } from "react-redux";
import { store } from "./Redux/store";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Box>
      <Provider store={store}>
        <App />
      </Provider>
    </Box>
  </React.StrictMode>
);
